import { useIdioma } from "../../i18n/IdiomaProvider";
import styles from "./Checkbox.module.css";

interface CheckboxProps {
  checado: boolean;
  onChange: (valor: boolean) => void;
  indeterminado?: boolean;
  titulo?: string;
  /** Nome acessível sem tooltip, usado em campos editáveis de conferência. */
  rotuloAcessivel?: string;
  disabled?: boolean;
}

/** Checkbox personalizado (não usa a aparência nativa do navegador). */
export function Checkbox({
  checado,
  onChange,
  indeterminado = false,
  titulo,
  rotuloAcessivel,
  disabled = false,
}: CheckboxProps) {
  const { traduzir } = useIdioma();
  const tituloTraduzido = titulo ? traduzir(titulo) : undefined;

  return (
    <label
      className={`${styles.wrap} ${disabled ? styles.disabled : ""} ${titulo ? "tooltip tooltipUp" : ""}`}
      data-tooltip={tituloTraduzido}
      onClick={(e) => e.stopPropagation()}
    >
      <input
        type="checkbox"
        className={styles.input}
        checked={checado}
        disabled={disabled}
        aria-label={rotuloAcessivel ? traduzir(rotuloAcessivel) : tituloTraduzido}
        ref={(el) => {
          if (el) el.indeterminate = indeterminado && !checado;
        }}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className={styles.caixa} aria-hidden="true" />
    </label>
  );
}
